import cloneDeep from 'lodash/cloneDeep';

export default function genererCopyRegleFacturation(regleFacturation) {
  const copy = cloneDeep(regleFacturation);
  delete copy.id;
  return copy;
}
